import { HistoryArrayFlags, HistoryEntry, historyToArray } from '@spazious/dollhouse-history';
import {
  FShallowGraph,
  GraphAction,
  graphReducer,
  shallowInitState,
} from '@spazious/dollhouse-shallow-graph';

export const historyBuildGraph = <TAction extends GraphAction, TMeta>(
  head: HistoryEntry<TAction[], TMeta>,
  initialState: FShallowGraph = shallowInitState
) => {
  if (!head || typeof head !== 'object') {
    throw new Error('Invalid history head');
  }
  return historyToArray(head, HistoryArrayFlags.Left)
    .flatMap(({ state }) => state)
    .reduce(graphReducer, initialState);
};
